module.exports = __webpack_public_path__ + "static/media/alan-ai-1.e3558875.gif";